function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1900(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31.12,
    height: 21.79,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6316666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 10.895
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.79,
    width: 31.12,
    height: 27.75,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9642857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 35.665
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.54,
    width: 31.12,
    height: 30.34,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 64.71
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 79.88,
    width: 31.12,
    height: 30.34,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.056666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 95.05
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110.23,
    width: 31.12,
    height: 31.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 125.985
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 141.74,
    width: 31.12,
    height: 32.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.393846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 157.82
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.9,
    width: 31.12,
    height: 33.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.445714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 190.76
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 207.61,
    width: 31.12,
    height: 34.75,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 224.985
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 242.37,
    width: 31.12,
    height: 35.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.445714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 259.94
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.51,
    width: 31.12,
    height: 40.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 297.935
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 318.36,
    width: 31.12,
    height: 42.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 339.755
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 361.15,
    width: 31.12,
    height: 43.83,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 383.065
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 404.98,
    width: 31.12,
    height: 44.74,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1866666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 427.35
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 449.72,
    width: 31.12,
    height: 49.15,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1866666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 474.295
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 498.87,
    width: 31.12,
    height: 49.41,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 523.575
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 548.28,
    width: 31.12,
    height: 50.44,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 573.5
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 598.72,
    width: 31.12,
    height: 50.44,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1866666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 623.94
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 649.17,
    width: 31.12,
    height: 50.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.457777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.56,
    y: 674.5849999999999
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 0,
    width: 36.25,
    height: 44.3,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.53125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.245000000000005,
    y: 22.15
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.37,
    y: 0,
    width: 36.71,
    height: 44.3,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.244285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.72500000000001,
    y: 22.15
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.08,
    y: 0,
    width: 37.99,
    height: 44.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.598000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.075,
    y: 22.15
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.07,
    y: 0,
    width: 38.53,
    height: 44.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.421666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.33499999999998,
    y: 22.15
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 0,
    width: 38.53,
    height: 44.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.843333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.865,
    y: 22.15
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.13,
    y: 0,
    width: 39.08,
    height: 44.3,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.513333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.67,
    y: 22.15
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.21,
    y: 0,
    width: 39.17,
    height: 44.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.528333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.79499999999996,
    y: 22.15
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.38,
    y: 0,
    width: 40.17,
    height: 44.3,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.034
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.465,
    y: 22.15
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.55,
    y: 0,
    width: 42.08,
    height: 44.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6755555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.59000000000003,
    y: 22.15
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.63,
    y: 0,
    width: 42.54,
    height: 44.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.9,
    y: 22.15
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.17,
    y: 0,
    width: 44.36,
    height: 44.3,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.383333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.35,
    y: 22.15
  }, "\n        Milton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.53,
    y: 0,
    width: 45.18,
    height: 44.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.383333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.11999999999995,
    y: 22.15
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.71,
    y: 0,
    width: 45.55,
    height: 44.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.485,
    y: 22.15
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.26,
    y: 0,
    width: 46,
    height: 44.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.383333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.26,
    y: 22.15
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.26,
    y: 0,
    width: 47.73,
    height: 44.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.383333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.125,
    y: 22.15
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.99,
    y: 0,
    width: 49.01,
    height: 44.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.495,
    y: 22.15
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 44.3,
    width: 49.86,
    height: 44.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.901111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 66.35499999999999
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 88.41,
    width: 49.86,
    height: 44.67,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 110.745
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 133.08,
    width: 49.86,
    height: 44.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 155.5
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 177.91,
    width: 49.86,
    height: 45.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4628571428571435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 200.53
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 223.16,
    width: 49.86,
    height: 45.81,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.162
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 246.065
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 268.96,
    width: 49.86,
    height: 45.81,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5442857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 291.865
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 314.77,
    width: 49.86,
    height: 46.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.701666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 337.875
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 360.98,
    width: 49.86,
    height: 47.18,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 384.57
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 408.16,
    width: 49.86,
    height: 47.43,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 431.875
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 455.59,
    width: 49.86,
    height: 47.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 479.30499999999995
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 503.01,
    width: 49.86,
    height: 47.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.855714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 527.005
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 551.01,
    width: 49.86,
    height: 48.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.792
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 575.49
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 599.97,
    width: 49.86,
    height: 49.77,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 624.855
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.12,
    y: 649.74,
    width: 49.86,
    height: 50.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.05,
    y: 674.87
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 44.3,
    width: 50.6,
    height: 50.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.032
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.28,
    y: 69.38
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.58,
    y: 44.3,
    width: 50.76,
    height: 50.16,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.96,
    y: 69.38
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.34,
    y: 44.3,
    width: 50.76,
    height: 50.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 207.72,
    y: 69.38
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.1,
    y: 44.3,
    width: 50.76,
    height: 50.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.48,
    y: 69.38
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.86,
    y: 44.3,
    width: 51.08,
    height: 50.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.40000000000003,
    y: 69.38
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.94,
    y: 44.3,
    width: 51.16,
    height: 50.16,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.52,
    y: 69.38
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.1,
    y: 44.3,
    width: 51.4,
    height: 50.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 411.8,
    y: 69.38
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.51,
    y: 44.3,
    width: 51.48,
    height: 50.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.25,
    y: 69.38
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 488.99,
    y: 44.3,
    width: 52.05,
    height: 50.16,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.015,
    y: 69.38
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.04,
    y: 44.3,
    width: 52.45,
    height: 50.16,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.265,
    y: 69.38
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.49,
    y: 44.3,
    width: 53.17,
    height: 50.16,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.075,
    y: 69.38
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.66,
    y: 44.3,
    width: 53.34,
    height: 50.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.3299999999999,
    y: 69.38
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 94.46,
    width: 51.92,
    height: 52.15,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.417142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 120.535
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 146.61,
    width: 51.92,
    height: 52.31,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.653333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 172.76500000000001
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 198.92,
    width: 51.92,
    height: 53.16,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.384
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 225.5
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 252.08,
    width: 51.92,
    height: 54.17,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.384
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 279.165
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 306.25,
    width: 51.92,
    height: 54.72,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.417142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 333.61
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 360.97,
    width: 51.92,
    height: 55.03,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 388.485
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 416,
    width: 51.92,
    height: 56.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.417142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 444.02
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 472.04,
    width: 51.92,
    height: 56.5,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.653333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 500.29
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 528.54,
    width: 51.92,
    height: 56.66,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 556.87
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 585.2,
    width: 51.92,
    height: 57.36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.417142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 613.88
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 642.56,
    width: 51.92,
    height: 57.44,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.417142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.94,
    y: 671.28
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 94.46,
    width: 52.89,
    height: 56.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.61125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.33499999999998,
    y: 122.88
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.78,
    y: 94.46,
    width: 53.81,
    height: 56.84,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.762
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.685,
    y: 122.88
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.6,
    y: 94.46,
    width: 55.38,
    height: 56.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.29,
    y: 122.88
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.97,
    y: 94.46,
    width: 55.52,
    height: 56.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.104000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.73,
    y: 122.88
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.49,
    y: 94.46,
    width: 56.51,
    height: 56.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.302
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.745,
    y: 122.88
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 94.46,
    width: 56.72,
    height: 56.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.36,
    y: 122.88
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.73,
    y: 94.46,
    width: 57.86,
    height: 56.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.66,
    y: 122.88
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.59,
    y: 94.46,
    width: 59.21,
    height: 56.84,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.120000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.195,
    y: 122.88
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.8,
    y: 94.46,
    width: 59.35,
    height: 56.84,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.4749999999999,
    y: 122.88
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.15,
    y: 94.46,
    width: 59.85,
    height: 56.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.368
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.0749999999999,
    y: 122.88
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 151.3,
    width: 58.19,
    height: 58.59,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.819
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 180.59500000000003
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 209.89,
    width: 58.19,
    height: 58.87,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 239.325
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 268.76,
    width: 58.19,
    height: 60.12,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.27375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 298.82
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 328.88,
    width: 58.19,
    height: 60.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.5475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 359.08
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 389.28,
    width: 58.19,
    height: 60.95,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4655555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 419.755
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 450.23,
    width: 58.19,
    height: 61.65,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.312857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 481.055
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 511.87,
    width: 58.19,
    height: 62.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.698333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 543.075
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 574.28,
    width: 58.19,
    height: 62.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.312857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 605.625
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 636.97,
    width: 58.19,
    height: 63.03,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.698333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.98499999999999,
    y: 668.485
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 151.3,
    width: 61.11,
    height: 60.09,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.63500000000002,
    y: 181.34500000000003
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.2,
    y: 151.3,
    width: 62.19,
    height: 60.09,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.584285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.29499999999996,
    y: 181.34500000000003
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.38,
    y: 151.3,
    width: 62.46,
    height: 60.09,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.018
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.61,
    y: 181.34500000000003
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.84,
    y: 151.3,
    width: 62.99,
    height: 60.09,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.018
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.335,
    y: 181.34500000000003
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.83,
    y: 151.3,
    width: 63.6,
    height: 60.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.584285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.63,
    y: 181.34500000000003
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.43,
    y: 151.3,
    width: 64.54,
    height: 60.09,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.0225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.7,
    y: 181.34500000000003
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.97,
    y: 151.3,
    width: 65.21,
    height: 60.09,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.584285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.575,
    y: 181.34500000000003
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.18,
    y: 151.3,
    width: 66.82,
    height: 60.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.5899999999999,
    y: 181.34500000000003
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 211.38,
    width: 68.15,
    height: 59.57,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.928333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.15500000000003,
    y: 241.165
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 270.95,
    width: 68.15,
    height: 59.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.518571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.15500000000003,
    y: 300.765
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 330.57,
    width: 68.15,
    height: 60.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.026666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.15500000000003,
    y: 360.65
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 390.73,
    width: 68.15,
    height: 60.16,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.15500000000003,
    y: 420.81
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 450.89,
    width: 68.15,
    height: 60.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.56375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.15500000000003,
    y: 481.145
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 511.41,
    width: 68.15,
    height: 61.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.15500000000003,
    y: 542.35
  }, "\n        De_Kalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 573.29,
    width: 68.15,
    height: 63.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.15500000000003,
    y: 604.9399999999999
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 636.58,
    width: 68.15,
    height: 63.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.684000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.15500000000003,
    y: 668.2900000000001
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.23,
    y: 211.38,
    width: 61.34,
    height: 70.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.815555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 289.90000000000003,
    y: 246.87
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.57,
    y: 211.38,
    width: 61.34,
    height: 70.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.762857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.24,
    y: 246.87
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.92,
    y: 211.38,
    width: 62.93,
    height: 70.98,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.488333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.385,
    y: 246.87
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444.85,
    y: 211.38,
    width: 63.1,
    height: 70.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.40000000000003,
    y: 246.87
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.96,
    y: 211.38,
    width: 63.22,
    height: 70.98,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.5699999999999,
    y: 246.87
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.17,
    y: 211.38,
    width: 63.84,
    height: 70.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.093333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.0899999999999,
    y: 246.87
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.02,
    y: 211.38,
    width: 64.98,
    height: 70.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.1225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.51,
    y: 246.87
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.23,
    y: 282.36,
    width: 72.83,
    height: 66.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.64500000000004,
    y: 315.63
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.23,
    y: 348.9,
    width: 72.83,
    height: 66.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.108333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.64500000000004,
    y: 382.22499999999997
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.23,
    y: 415.55,
    width: 72.83,
    height: 66.82,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.64500000000004,
    y: 448.96000000000004
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.23,
    y: 482.37,
    width: 72.83,
    height: 72.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.023333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.64500000000004,
    y: 518.44
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.23,
    y: 554.51,
    width: 72.83,
    height: 72.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.64500000000004,
    y: 590.58
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.23,
    y: 626.64,
    width: 72.83,
    height: 73.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.10375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.64500000000004,
    y: 663.3199999999999
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.06,
    y: 282.36,
    width: 69.91,
    height: 77.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.651666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.015,
    y: 321.115
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.97,
    y: 282.36,
    width: 71.42,
    height: 77.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.903333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.68,
    y: 321.115
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.4,
    y: 282.36,
    width: 71.58,
    height: 77.51,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.225714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.19,
    y: 321.115
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.97,
    y: 282.36,
    width: 76.78,
    height: 77.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.36,
    y: 321.115
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.76,
    y: 282.36,
    width: 78.24,
    height: 77.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.072857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.88,
    y: 321.115
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.06,
    y: 359.87,
    width: 74.24,
    height: 82.61,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.18,
    y: 401.175
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.06,
    y: 442.49,
    width: 74.24,
    height: 84.08,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.18,
    y: 484.53000000000003
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.06,
    y: 526.57,
    width: 74.24,
    height: 85.66,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.18,
    y: 569.4000000000001
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.06,
    y: 612.22,
    width: 74.24,
    height: 87.78,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.373333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.18,
    y: 656.11
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.3,
    y: 359.87,
    width: 68.07,
    height: 96.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.724285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.33500000000004,
    y: 408.155
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.37,
    y: 359.87,
    width: 69.28,
    height: 96.57,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.01,
    y: 408.155
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.65,
    y: 359.87,
    width: 74.17,
    height: 96.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.361666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.735,
    y: 408.155
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.81,
    y: 359.87,
    width: 82.19,
    height: 96.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.741428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.905,
    y: 408.155
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.3,
    y: 456.44,
    width: 109.78,
    height: 78.48,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.696000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.19,
    y: 495.68
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.3,
    y: 534.92,
    width: 109.78,
    height: 80.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.19,
    y: 575.15
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.3,
    y: 615.38,
    width: 109.78,
    height: 84.62,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.19,
    y: 657.69
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.08,
    y: 456.44,
    width: 183.92,
    height: 93.79,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.39857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 608.0400000000001,
    y: 503.335
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.08,
    y: 550.24,
    width: 183.92,
    height: 149.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.959999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 608.0400000000001,
    y: 625.12
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1900);
export default __webpack_public_path__ + "static/media/1900.562db6a69141669a05280ac8dbac2f2a.svg";
export { ForwardRef as ReactComponent };